import CenteredLayout from '@/layouts/CenteredLayout.vue';
import ObjectInfo from '@/views/Brand/Objects/Components/ObjectInfo.vue';
import ObjectMap from '@/views/Brand/Objects/Components/ObjectMap.vue';
import ImageCarousel from '@/components/ImageCarousel/ImageCarousel.vue';
import PriceBox from '@/views/Brand/Objects/Components/PriceBox.vue';
import { ObjectDetailsPlacePreview } from '@/views/Brand/Objects/_constants';
import CreateReportWithObjectButton from '@/views/Brand/Objects/_components/create-report-with-object-button/create-report-with-object-button.vue';
import { BtnTheme } from '@/components/Btn';
import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useObjects } from '@/composables';
import { getObjectAttachmentList, FileType, } from '@/api/v2/requests/files';
export default defineComponent({
    components: {
        CreateReportWithObjectButton,
        PriceBox,
        CenteredLayout,
        ObjectMap,
        ObjectInfo,
        ImageCarousel,
    },
    props: {
        offerObject: {
            type: Boolean,
            default: false,
        },
        placePreview: {
            type: String,
            default: ObjectDetailsPlacePreview.POPOVER,
        },
        isModalChildren: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        const { object, objectType } = useObjects();
        const multimediaAttachments = ref([]);
        const isLoadingAttachments = ref(false);
        const fetchAttachments = async (objectId) => {
            if (!objectId)
                return;
            isLoadingAttachments.value = true;
            try {
                const { nodes } = await getObjectAttachmentList({
                    objectId,
                    type: FileType.MULTIMEDIA,
                    perPage: 100,
                });
                multimediaAttachments.value = nodes;
            }
            catch (error) {
                console.error(error);
            }
            finally {
                isLoadingAttachments.value = false;
            }
        };
        watch(() => object.value?.id, (objectId) => {
            if (objectId) {
                fetchAttachments(objectId);
            }
        }, { immediate: true });
        const computedImages = computed(() => {
            const images = [];
            if (object.value?.logoUrl) {
                images.push({
                    url: object.value.logoUrl,
                    name: 'object image',
                });
            }
            if (multimediaAttachments.value?.length) {
                const attachmentImages = multimediaAttachments.value.map((file) => ({
                    url: file.url,
                    name: file.originalFileName || 'attachment',
                }));
                images.push(...attachmentImages);
            }
            return images;
        });
        return {
            object,
            objectType,
            BtnTheme,
            computedImages,
            isLoadingAttachments,
        };
    },
});
